<template>
  <b-modal
    id="doorCreator-modal"
    ref="doorCreator_modal"
    title="Kreator drzwi"
    @hidden="onClose"
    size="lg"
  >
    <ValidationObserver
      ref="doorCreatorValidation"
      tag="form"
      @submit.prevent="onSubmit"
      id="doorform"
    >
      <h4>Drzwi:</h4>
      <b-container>
          <b-row>
            <b-col>
              <b-form-group label="Rodzaj:" label-for="door-model" class="required">
                <ValidationProvider
                  name="door-model"
                  rules="required"
                  v-slot="validationContext"
                >
                  <b-form-select 
                    id="door-model"
                    v-model="door.model"
                    :options="doorModels"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
              <b-form-group label="Typ:" label-for="door-type" class="required">
                <ValidationProvider
                  name="door-type"
                  rules="required"
                  v-slot="validationContext"
                >
                  <b-form-select 
                    id="door-type"
                    v-model="door.type"
                    :options="doorTypes"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
              <b-form-group label="Zamek:" label-for="door-lock" class="required">
                <ValidationProvider
                  name="door-lock"
                  rules="required"
                  v-slot="validationContext"
                >
                  <b-form-select 
                    id="door-lock"
                    v-model="door.lock"
                    :options="doorLocks"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Wysokość (Otwór drzwiowy):" label-for="door-height" class="required">
                <ValidationProvider
                  name="door-height"
                  rules="required"
                  v-slot="validationContext"
                >
                  <b-form-select 
                    id="door-height"
                    v-model="door.height"
                    :options="doorHeights"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
              <b-form-group label="Szerokość (Otwór drzwiowy):" label-for="door-width" class="required">
                <ValidationProvider
                  name="door-width"
                  rules="required"
                  v-slot="validationContext"
                >
                  <b-form-select 
                    id="door-width"
                    v-model="door.width"
                    :options="doorWidths"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
              <b-form-group label="Grubość muru (tolerancja)" label-for="door-thickness" class="required">
                <ValidationProvider
                  name="door-thickness"
                  rules="required"
                  v-slot="validationContext"
                >
                  <b-form-select 
                    id="door-thickness"
                    v-model="door.thickness"
                    :options="doorThickness"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Ilość: " label-for="door-quantity">
                      <b-form-input
                        id="door-quantity"
                        v-model="door.quantity"
                        type="number"
                        placeholder="1"
                        min="1"
                      />
                </b-form-group>
              </b-col>
              <b-col></b-col>
            </b-row>
        </b-container>
      <b-form-group label="Kierunek:" v-slot="{ ariaDescribedby }">
        <b-container>
          <b-row>
            <b-col>
              <b-form-radio
                v-model="door.direction"
                :aria-describedby="ariaDescribedby"
                name="door-direction"
                value="L"
              >
                Lewe
                <b-img 
                  :src="require('../../assets/image/doors-left.svg')"
                  fluid-grow
                  alt="Fluid-grow image"
                />
              </b-form-radio>
            </b-col>
            <b-col>
              <b-form-radio
                v-model="door.direction"
                :aria-describedby="ariaDescribedby"
                name="door-direction"
                value="P"
              >
                Prawe
                <b-img 
                  :src="require('../../assets/image/doors-right.svg')"
                  fluid-grow
                  alt="Fluid-grow image"
                />
              </b-form-radio>
            </b-col>
          </b-row>
        </b-container>
      </b-form-group>

      <h4>Wcięcie na szybę:</h4>
      <b-container>
          <b-row>
            <b-col>
              <b-form-group label="Szyba:" label-for="door-window-type">
                <b-form-select 
                  id="door-window-type"
                  v-model="door.window.type"
                  :options="windowTypes"
                  @input="resetWindow()"
                />
              </b-form-group>
              <b-form-group label="Wysokość (mm):" label-for="door-window-height"
                v-show="door.window.type != null"
              >
                <b-form-input
                  id="door-window-height"
                  v-model="door.window.height"
                  type="number"
                  min=0
                />
              </b-form-group>
              <b-form-group label="Szerokość (mm):" label-for="door-window-width"
                v-show="door.window.type != null"
              >
                <b-form-input
                  id="door-window-width"
                  v-model="door.window.width"
                  type="number"
                  min=0
                />
              </b-form-group>
            </b-col>
            <b-col></b-col>
          </b-row>
      </b-container>
    </ValidationObserver>
    <template v-slot:modal-footer="{ cancel }">
      <b-button size="md" variant="primary" type="submit" form="doorform">
        Zapisz
      </b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">
        Anuluj
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: "DoorCreatorModalForm",
  data() {
    return {
      door: {
        model: null,
        width: null,
        height: null,
        thickness: null,
        type: null,
        lock: null,
        direction: 'Lewe',
        quantity: 1,
        window: {
          type: null,
          width: 0,
          height: 0
        }
      },
      doorModels: [
        { value: null, text: '--Wybierz rodzaj--' },
        { value: 'Innentür Röhrenspaneinlage CPL, Rundkante inkl. Tür-Montagefutter, BB-Einsteckschloß', text: 'Innentür Röhrenspaneinlage CPL, Rundkante inkl. Tür-Montagefutter, BB-Einsteckschloß' },
        { value: 'Innentür Röhrenspaneinlage CPL, Rundkante inkl. Tür-Montagefutter WC-Schloß', text: 'Innentür Röhrenspaneinlage CPL, Rundkante inkl. Tür-Montagefutter WC-Schloß' }
      ],
      doorHeights: [
        { value: null, text: '--Wybierz wysokość--' },
        { value: 2005, text: '2005' },
        { value: 2113, text: '2113' }
      ],
      doorWidths: [
        { value: null, text: '--Wybierz szerokość--' },
        { value: 635, text: '635' },
        { value: 760, text: '760' },
        { value: 885, text: '885' },
        { value: 1010, text: '1010' }
      ],
      doorThickness: [
        { value: null, text: '--Wybierz grubość--' },
        { value: '80-96', text: '80-96' },
        { value: '100-116', text: '100-116' },
        { value: '121-141', text: '121-141' },
        { value: '121-141', text: '141-161' },
        { value: '161-181', text: '161-181' },
        { value: '181-201', text: '181-201' },
        { value: '201-221', text: '201-221' },
        { value: '236-256', text: '236-256' },
        { value: '266-286', text: '266-286' }
      ],
      doorTypes: [
        { value: null, text: '--Wybierz typ--' },
        { value: 'Normal', text: 'Gładkie' },
        { value: 'como', text: 'Como' },
        { value: 'wet', text: 'Wejściowe' }
      ],
      doorLocks: [
        { value: null, text: '--Wybierz zamek--' },
        { value: 'BB', text: 'BB' },
        { value: 'PZ', text: 'PZ' },
        { value: 'WC', text: 'WC' }
      ],
      windowTypes: [
        { value: null, text: 'Brak' },
        { value: 'Klar', text: 'Klar' },
        { value: 'Satinato', text: 'Satinato' }
      ],
    };
  },
  methods: {
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onClose() {
      this.door = {
        model: null,
        width: null,
        height: null,
        thickness: null,
        type: null,
        lock: null,
        direction: 'L',
        quantity: 1,
        window: {
          type: null,
          width: 1,
          height: 1
        }
      },
      this.$emit("onClose");
    },
    cancel() {
      this.onClose();
    },
    onSubmit() {
      this.$refs.doorCreatorValidation.validate().then(success => {
        if (!success) {
          return;
        }
        this.$emit("onSubmit", this.door);
        this.$nextTick(() => {
          this.$bvModal.hide("doorCreator-modal");
        });
      });
    },
    resetWindow() {
      if (this.door.window.type == null) {
        this.door.window.height = 0;
        this.door.window.width = 0;
      }
    }
  },
};
</script>
